import * as React from 'react';
import { IconArrowLeft16 } from '@cian/ui-kit';

import * as style from './style.css';

export interface ILeftArrowProps {
  onClick: () => void;
}

export const LeftArrow: React.FC<ILeftArrowProps> = ({ onClick }) => {
  return (
    <div className={style['item']} onClick={onClick}>
      <IconArrowLeft16 color="gray_icons_100" />
    </div>
  );
};
